export const SECTION_URL_MAP: Record<string, string> = {
  'Quick Start': '/quick-start',
} as const
